export const countryWithCode = [
  { code: "AF", name: "Afghanistan", prefix: "+93" },
  { code: "AL", name: "Albania", prefix: "+355" },
  { code: "DZ", name: "Algeria", prefix: "+213" },
  { code: "AS", name: "American Samoa", prefix: "+1-684" },
  { code: "AD", name: "Andorra", prefix: "+376" },
  { code: "AO", name: "Angola", prefix: "+244" },
  { code: "AI", name: "Anguilla", prefix: "+1-264" },
  { code: "AQ", name: "Antarctica", prefix: "+672" },
  { code: "AG", name: "Antigua and Barbuda", prefix: "+1-268" },
  { code: "AR", name: "Argentina", prefix: "+54" },
  { code: "AM", name: "Armenia", prefix: "+374" },
  { code: "AU", name: "Australia", prefix: "+61" },
  { code: "AT", name: "Austria", prefix: "+43" },
  { code: "AZ", name: "Azerbaijan", prefix: "+994" },
  { code: "BH", name: "Bahrain", prefix: "+973" },
  { code: "BD", name: "Bangladesh", prefix: "+880" },
  { code: "BY", name: "Belarus", prefix: "+375" },
  { code: "BE", name: "Belgium", prefix: "+32" },
  { code: "BJ", name: "Benin", prefix: "+229" },
  { code: "BT", name: "Bhutan", prefix: "+975" },
  { code: "BO", name: "Bolivia", prefix: "+591" },
  { code: "BA", name: "Bosnia and Herzegovina", prefix: "+387" },
  { code: "BW", name: "Botswana", prefix: "+267" },
  { code: "BR", name: "Brazil", prefix: "+55" },
  { code: "BN", name: "Brunei", prefix: "+673" },
  { code: "BG", name: "Bulgaria", prefix: "+359" },
  { code: "BF", name: "Burkina Faso", prefix: "+226" },
  { code: "BI", name: "Burundi", prefix: "+257" },
  { code: "KH", name: "Cambodia", prefix: "+855" },
  { code: "CM", name: "Cameroon", prefix: "+237" },
  { code: "CA", name: "Canada", prefix: "+1" },
  { code: "CV", name: "Cape Verde", prefix: "+238" },
  { code: "CF", name: "Central African Republic", prefix: "+236" },
  { code: "TD", name: "Chad", prefix: "+235" },
  { code: "CL", name: "Chile", prefix: "+56" },
  { code: "CN", name: "China", prefix: "+86" },
  { code: "CO", name: "Colombia", prefix: "+57" },
  { code: "KM", name: "Comoros", prefix: "+269" },
  { code: "CD", name: "Congo (DRC)", prefix: "+243" },
  { code: "CG", name: "Congo (Republic)", prefix: "+242" },
  { code: "CR", name: "Costa Rica", prefix: "+506" },
  { code: "CI", name: "Côte d’Ivoire", prefix: "+225" },
  { code: "HR", name: "Croatia", prefix: "+385" },
  { code: "CU", name: "Cuba", prefix: "+53" },
  { code: "CY", name: "Cyprus", prefix: "+357" },
  { code: "CZ", name: "Czech Republic", prefix: "+420" },
  { code: "DK", name: "Denmark", prefix: "+45" },
  { code: "DJ", name: "Djibouti", prefix: "+253" },
  { code: "DO", name: "Dominican Republic", prefix: "+1-809" },
  { code: "EC", name: "Ecuador", prefix: "+593" },
  { code: "EG", name: "Egypt", prefix: "+20" },
  { code: "SV", name: "El Salvador", prefix: "+503" },
  { code: "GQ", name: "Equatorial Guinea", prefix: "+240" },
  { code: "ER", name: "Eritrea", prefix: "+291" },
  { code: "EE", name: "Estonia", prefix: "+372" },
  { code: "ET", name: "Ethiopia", prefix: "+251" },
  { code: "FJ", name: "Fiji", prefix: "+679" },
  { code: "FI", name: "Finland", prefix: "+358" },
  { code: "FR", name: "France", prefix: "+33" },
  { code: "GA", name: "Gabon", prefix: "+241" },
  { code: "GM", name: "Gambia", prefix: "+220" },
  { code: "GE", name: "Georgia", prefix: "+995" },
  { code: "DE", name: "Germany", prefix: "+49" },
  { code: "GH", name: "Ghana", prefix: "+233" },
  { code: "GR", name: "Greece", prefix: "+30" },
  { code: "GT", name: "Guatemala", prefix: "+502" },
  { code: "GN", name: "Guinea", prefix: "+224" },
  { code: "GY", name: "Guyana", prefix: "+592" },
  { code: "HT", name: "Haiti", prefix: "+509" },
  { code: "HN", name: "Honduras", prefix: "+504" },
  { code: "HK", name: "Hong Kong", prefix: "+852" },
  { code: "HU", name: "Hungary", prefix: "+36" },
  { code: "IS", name: "Iceland", prefix: "+354" },
  { code: "IN", name: "India", prefix: "+91" },
  { code: "ID", name: "Indonesia", prefix: "+62" },
  { code: "IR", name: "Iran", prefix: "+98" },
  { code: "IQ", name: "Iraq", prefix: "+964" },
  { code: "IE", name: "Ireland", prefix: "+353" },
  { code: "IL", name: "Israel", prefix: "+972" },
  { code: "IT", name: "Italy", prefix: "+39" },
  { code: "JM", name: "Jamaica", prefix: "+1-876" },
  { code: "JP", name: "Japan", prefix: "+81" },
  { code: "JO", name: "Jordan", prefix: "+962" },
  { code: "KZ", name: "Kazakhstan", prefix: "+7" },
  { code: "KE", name: "Kenya", prefix: "+254" },
  { code: "KR", name: "South Korea", prefix: "+82" },
  { code: "KW", name: "Kuwait", prefix: "+965" },
  { code: "KG", name: "Kyrgyzstan", prefix: "+996" },
  { code: "LA", name: "Laos", prefix: "+856" },
  { code: "LV", name: "Latvia", prefix: "+371" },
  { code: "LB", name: "Lebanon", prefix: "+961" },
  { code: "LS", name: "Lesotho", prefix: "+266" },
  { code: "LR", name: "Liberia", prefix: "+231" },
  { code: "LY", name: "Libya", prefix: "+218" },
  { code: "LT", name: "Lithuania", prefix: "+370" },
  { code: "LU", name: "Luxembourg", prefix: "+352" },
  { code: "MO", name: "Macau", prefix: "+853" },
  { code: "MG", name: "Madagascar", prefix: "+261" },
  { code: "MW", name: "Malawi", prefix: "+265" },
  { code: "MY", name: "Malaysia", prefix: "+60" },
  { code: "MV", name: "Maldives", prefix: "+960" },
  { code: "ML", name: "Mali", prefix: "+223" },
  { code: "MT", name: "Malta", prefix: "+356" },
  { code: "MX", name: "Mexico", prefix: "+52" },
  { code: "MD", name: "Moldova", prefix: "+373" },
  { code: "MC", name: "Monaco", prefix: "+377" },
  { code: "MN", name: "Mongolia", prefix: "+976" },
  { code: "ME", name: "Montenegro", prefix: "+382" },
  { code: "MA", name: "Morocco", prefix: "+212" },
  { code: "MZ", name: "Mozambique", prefix: "+258" },
  { code: "MM", name: "Myanmar (Burma)", prefix: "+95" },
  { code: "NA", name: "Namibia", prefix: "+264" },
  { code: "NP", name: "Nepal", prefix: "+977" },
  { code: "NL", name: "Netherlands", prefix: "+31" },
  { code: "NZ", name: "New Zealand", prefix: "+64" },
  { code: "NG", name: "Nigeria", prefix: "+234" },
  { code: "NO", name: "Norway", prefix: "+47" },
  { code: "OM", name: "Oman", prefix: "+968" },
  { code: "PK", name: "Pakistan", prefix: "+92" },
  { code: "PS", name: "Palestine", prefix: "+970" },
  { code: "PA", name: "Panama", prefix: "+507" },
  { code: "PG", name: "Papua New Guinea", prefix: "+675" },
  { code: "PY", name: "Paraguay", prefix: "+595" },
  { code: "PE", name: "Peru", prefix: "+51" },
  { code: "PH", name: "Philippines", prefix: "+63" },
  { code: "PL", name: "Poland", prefix: "+48" },
  { code: "PT", name: "Portugal", prefix: "+351" },
  { code: "QA", name: "Qatar", prefix: "+974" },
  { code: "RO", name: "Romania", prefix: "+40" },
  { code: "RU", name: "Russia", prefix: "+7" },
  { code: "RW", name: "Rwanda", prefix: "+250" },
  { code: "SA", name: "Saudi Arabia", prefix: "+966" },
  { code: "SN", name: "Senegal", prefix: "+221" },
  { code: "RS", name: "Serbia", prefix: "+381" },
  { code: "SG", name: "Singapore", prefix: "+65" },
  { code: "SK", name: "Slovakia", prefix: "+421" },
  { code: "SI", name: "Slovenia", prefix: "+386" },
  { code: "ZA", name: "South Africa", prefix: "+27" },
  { code: "ES", name: "Spain", prefix: "+34" },
  { code: "LK", name: "Sri Lanka", prefix: "+94" },
  { code: "SD", name: "Sudan", prefix: "+249" },
  { code: "SE", name: "Sweden", prefix: "+46" },
  { code: "CH", name: "Switzerland", prefix: "+41" },
  { code: "SY", name: "Syria", prefix: "+963" },
  { code: "TW", name: "Taiwan", prefix: "+886" },
  { code: "TZ", name: "Tanzania", prefix: "+255" },
  { code: "TH", name: "Thailand", prefix: "+66" },
  { code: "TR", name: "Turkey", prefix: "+90" },
  { code: "UG", name: "Uganda", prefix: "+256" },
  { code: "UA", name: "Ukraine", prefix: "+380" },
  { code: "AE", name: "United Arab Emirates", prefix: "+971" },
  { code: "GB", name: "United Kingdom", prefix: "+44" },
  { code: "US", name: "United States", prefix: "+1" },
  { code: "UY", name: "Uruguay", prefix: "+598" },
  { code: "UZ", name: "Uzbekistan", prefix: "+998" },
  { code: "VE", name: "Venezuela", prefix: "+58" },
  { code: "VN", name: "Vietnam", prefix: "+84" },
  { code: "YE", name: "Yemen", prefix: "+967" },
  { code: "ZM", name: "Zambia", prefix: "+260" },
  { code: "ZW", name: "Zimbabwe", prefix: "+263" },
];
